import moment from 'moment';
import QRCode from 'qrcode';

export const encodeEscapeSequence = (data) => {
    var regexp = /\\[tnr\\]/g;

    if (regexp.test(data)) {
        data = data.replace(regexp, function (match) {
            switch (match) {
                case '\\t' : return '\\x09';
                case '\\n' : return '\\x0a';
                case '\\r' : return '\\x0d';
            }

            return '\\x5c';
        });
    }

    var regexp = /\\[Xx][0-9A-Fa-f]{2}/g;

    if (regexp.test(data)) {
        data = data.replace(regexp, function (match) {
            return String.fromCharCode(parseInt(match.slice(2), 16));
        });
    }

    return data;
}

export const generateFGLTicket = async (label, client, customer, builder) => {
    let section;
    let row;
    let seat;
    let stubSection;

    let dateShort = moment(label.event_date.event_datetime_local.substring(0, 19)).format('ddd, MMM Do YYYY @ h:mm a');
    let dateLong = moment(label.event_date.event_datetime_local.substring(0, 19)).format('LLLL').toString();

    let SectionRowSeat = label.full_seat_name.split(':');
    if (label.venue.venue_type === 'general-admission') {
        section = ``;
        row = `General Admission: `;
        seat = `${SectionRowSeat[2]}`;
        stubSection =`General Admission`;
    } else {
        section = `Section: ${SectionRowSeat[0]} `;
        row = `Row: ${SectionRowSeat[1]} `;
        seat = `Seat: ${SectionRowSeat[2]}`;
        stubSection = section + ' ' + row;
    }

    let dateStub2 = dateShort.split('@')[1].trim();
    let fullAddress = label.venue.address.trim() + ', ' + label.venue.city.trim() + ', ' + label.venue.state.trim() + ', ' + label.venue.zip;
    stubSection = (stubSection.replace(/ +(?= )/g,'').length > 28)
        ? stubSection.replace(/ +(?= )/g,'').substring(0, 28)
        : stubSection.replace(/ +(?= )/g,'');
    const price = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(label.price);

    let venueName = label.venue.name;

    // If event is not an event
    // Tickets - Event Type Customization #1145
    if (label.event.event_type && label.event.event_type !== 'Event') {
        fullAddress = '';
        dateStub2 = '';
        dateShort = '';
        dateLong = '';
        venueName = '';
    }

    let _customer = {
        first_name: customer.first_name,
        last_name: customer.last_name,
    };
    if (label.customer) {
        _customer.first_name = label.customer.first_name;
        _customer.last_name = label.customer.last_name;
    }

    let qrCode = '';

    let cmds = '';
    //if (!isBluetooth) {
        cmds += builder.createAlignmentElement({position:'center'});
        cmds += builder.createTextElement({data:`---------------------\n`});
        cmds += builder.createTextElement({data:`\n`});
        cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Your ticket for ${client.client_name}\n`});
        cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:true, underline:false, invert:false, binary:false, data:`${label.event.name}\n`});
        cmds += builder.createTextElement({data:`\n`});
        cmds += builder.createTextElement({data:`---------------------\n`});
        cmds += builder.createTextElement({data:`\n`});
        
        cmds += builder.createAlignmentElement({position:'left'});
        if (dateLong !== '') {
            cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${dateLong}\n`});
        }
        if (label.event.event_type !== 'Live Stream' && label.event.event_type !== 'Scheduled Content' && label.event.event_type !== 'Video On Demand') {
            if (venueName !== '') {
                cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:true, invert:false, binary:false, data:`At ${venueName}\n`});
            }
            if (fullAddress !== '') {
                cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${fullAddress}\n`});
            }
            cmds += builder.createAlignmentElement({position:'center'});
            cmds += builder.createTextElement({data:`\n`});
            cmds += builder.createTextElement({data:`---------------------\n`});
        }
        cmds += builder.createTextElement({data:`\n`});
        cmds += builder.createAlignmentElement({position:'left'});
        
        cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${_customer.first_name} ${_customer.last_name} \n`});
        cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Transaction ID: ${label.transaction_id}\n`});
        cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Ticket ID: ${label.id}\n`});
        if (section !== '') {
            cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:true, binary:false, data:`${section}${row}${seat}\n`});
        }
        if (price !== '') {
            cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${price}\n`});
            cmds += builder.createTextElement({data:`\n`});
            cmds += builder.createAlignmentElement({position:'center'});
            cmds += builder.createTextElement({data:`---------------------\n`});
            cmds += builder.createTextElement({data:`\n`});
        }
        cmds += builder.createAlignmentElement({position:'center'});
        if (label.event.event_type === 'Live Stream' || label.event.event_type === 'Scheduled Content' || label.event.event_type === 'Video On Demand') {
            cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Visit ShowTix4U.com/stream and enter ${label.activation_code}\n`});
            cmds += builder.createTextElement({data:`\n`});
            cmds += builder.createQrCodeElement({model:'model2', level:'level_l', cell:8, data:encodeEscapeSequence(`https://www.showtix4u.com/stream/${label.activation_code}`)});
        } else {
            cmds += builder.createQrCodeElement({model:'model2', level:'level_l', cell:8, data:encodeEscapeSequence(label.id)});
        }
        cmds += builder.createTextElement({data:`\n`});
        cmds += builder.createTextElement({data:`\n`});
        cmds += builder.createCutPaperElement({feed:true});
    return cmds;
};

export const generateFGLTicketUSB = async (label, client, customer, builder) => {
    let section;
    let row;
    let seat;
    let stubSection;

    let dateShort = moment(label.event_date.event_datetime_local.substring(0, 19)).format('ddd, MMM Do YYYY @ h:mm a');
    let dateLong = moment(label.event_date.event_datetime_local.substring(0, 19)).format('LLLL').toString();

    let SectionRowSeat = label.full_seat_name.split(':');
    if (label.venue.venue_type === 'general-admission') {
        section = ``;
        row = `General Admission: `;
        seat = `${SectionRowSeat[2]}`;
        stubSection =`General Admission`;
    } else {
        section = `Section: ${SectionRowSeat[0]} `;
        row = `Row: ${SectionRowSeat[1]} `;
        seat = `Seat: ${SectionRowSeat[2]}`;
        stubSection = section + ' ' + row;
    }

    let dateStub2 = dateShort.split('@')[1].trim();
    let fullAddress = label.venue.address.trim() + ', ' + label.venue.city.trim() + ', ' + label.venue.state.trim() + ', ' + label.venue.zip;
    stubSection = (stubSection.replace(/ +(?= )/g,'').length > 28)
        ? stubSection.replace(/ +(?= )/g,'').substring(0, 28)
        : stubSection.replace(/ +(?= )/g,'');
    const price = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(label.price);

    let venueName = label.venue.name;

    // If event is not an event
    // Tickets - Event Type Customization #1145
    if (label.event.event_type && label.event.event_type !== 'Event') {
        fullAddress = '';
        dateStub2 = '';
        dateShort = '';
        dateLong = '';
        venueName = '';
    }

    let _customer = {
        first_name: customer.first_name,
        last_name: customer.last_name,
    };
    if (label.customer) {
        _customer.first_name = label.customer.first_name;
        _customer.last_name = label.customer.last_name;
    }

    let qrCode = '';

    let cmds = '';
        cmds += `---------------------\n`;
        cmds += `\n`;
        cmds += `Your ticket for ${client.client_name}\n`;
        cmds += `${label.event.name}\n`;
        cmds += `\n`;
        cmds += `---------------------\n`;
        cmds += `\n`;
       
        if (dateLong !== '') {
            cmds += `${dateLong}\n`;
        }
        cmds += `\n`;
        if (label.event.event_type !== 'Live Stream' && label.event.event_type !== 'Scheduled Content' && label.event.event_type !== 'Video On Demand') {
            if (venueName !== '') {
                cmds += `${venueName}\n`;
            }
            if (fullAddress !== '') {
                cmds += `${fullAddress}\n`;
            }
            cmds += `\n`;
            cmds += `---------------------\n`;
        }
        cmds += `\n`;
        
        cmds += `${_customer.first_name} ${_customer.last_name}\n`;
        cmds += `Transaction ID: ${label.transaction_id}\n`;
        cmds += `Ticket ID: ${label.id}\n`;
        cmds += `\n`;
        if (section !== '') {
            cmds += `${section}${row}${seat}\n`;
        }
        if (price !== '') {
            cmds += `${price}\n`;
            cmds += `\n`;
            cmds += `---------------------\n`;
            cmds += `\n`;
        }
        if (label.event.event_type === 'Live Stream' || label.event.event_type === 'Scheduled Content' || label.event.event_type === 'Video On Demand') {
            cmds += `Visit ShowTix4U.com/stream and enter ${label.activation_code}\n`;
            cmds += `\n`;
        }
       
        cmds += `\n`;
        cmds += `\n`;
        cmds += `---------------------\n`;
        cmds += `\n`;
    return cmds;
};

export const generateFGLFlexpass = (label, client, builder) => {
    let cmds = '';
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${client.client_name}\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${label.name}\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Thank you for purchasing a Flex Pass!\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`PLEASE BE SURE TO KEEP THIS\nTICKET.\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`When you are ready to purchase\nyour individual tickets, please\nuse the code below during\nthe purchase process.\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`You do not have to redeem all\nyour tickets at once.\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`Some events may be restricted\nfrom use with Flex Passes.\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`This Flex Pass it worth ${label.max_tickets}\ntickets.\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:true, binary:false, data:`Code: ${label.code}\n`});
    cmds += builder.createCutPaperElement({feed:true});
    return cmds;
};

export const generateFGLFlexpassUSB = (label, client) => {
    let cmds = '';
    cmds += `${client.client_name}\n\n`;
    cmds += `${label.name}\n\n`;
    cmds += `Thank you for purchasing a Flex Pass!\n\n`;
    cmds += `PLEASE BE SURE TO KEEP THIS\nTICKET.\n\n`;
    cmds += `When you are ready to purchase\nyour individual tickets, please\nuse the code below during\nthe purchase process.\n`;
    cmds += `You do not have to redeem all\nyour tickets at once.\n`;
    cmds += `Some events may be restricted\nfrom use with Flex Passes.\n`;
    cmds += `This Flex Pass it worth ${label.max_tickets}\ntickets.\n`;
    cmds += `Code: ${label.code}\n`;
    cmds += `\n`;
    cmds += `\n`;
    cmds += `---------------------\n`;
    cmds += `\n`;
    return cmds;
};

export const generateFGLCoupon = (label, client, builder) => {
    let cmds = '';
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${client.client_name}\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${label.couponName}\n\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:false, binary:false, data:`${label.couponDescription}\n`});
    cmds += builder.createTextElement({characterspace:0, linespace:32, width:1, height:1, emphasis:false, underline:false, invert:true, binary:false, data:`Code: ${label.code}\n`});
    cmds += builder.createCutPaperElement({feed:true});
    return cmds;
};

export const generateFGLCouponUSB = (label, client) => {
    let cmds = '';
    cmds += `${client.client_name}\n\n`;
    cmds += `${label.couponName}\n\n`;
    cmds += `${label.couponDescription}\n`;
    cmds += `Code: ${label.code}\n`;
    cmds += `\n`;
    cmds += `\n`;
    cmds += `---------------------\n`;
    cmds += `\n`;
    return cmds;
};


// WEBPACK FOOTER //
// ./src/lib/labels/star/templates.js